<div class="tabs">
  <div class="tabs__nav text--center">
    <button
      *ngFor="let tab of tabs"
      class="tab"
      [class.tab--active]="tab.active"
      (click)="selectTab(tab); $event.stopPropagation()"
    >
      <h4 class="typog-body-large-bold">{{ tab.title }}</h4>
    </button>
  </div>
  <ng-content></ng-content>
</div>
